import { Link } from "react-router-dom";
import { NextDayButton } from "@/components/site/NextDayButton";
import Hero from "@/components/site/Hero";
import ServicesGrid from "@/components/site/ServicesGrid";
import ContactBlock from "@/components/site/ContactBlock";
import { Reviews, WhyCora, InstagramCta } from "@/components/site/Sections";
import { Reveal, SectionTitle, Typewriter } from "@/components/site/Reveal";
import { usePageMeta } from "@/components/site/usePageMeta";
import BlogTeaser from "@/components/site/BlogTeaser";
import SjdsDivider from "@/components/site/SjdsDivider";
import ManaguaDivider from "@/components/site/ManaguaDivider";
import InstagramFeed from "@/components/site/InstagramFeed";
import { useLang } from "@/i18n/LangContext";

export default function Home() {
  const { tr } = useLang();
  usePageMeta(
    tr("Dentist in San Juan del Sur & Managua, Nicaragua", "Dentista en San Juan del Sur y Managua, Nicaragua"),
    tr("Dra. Cora Baltodano, DDS – orthodontics specialist. Implants, Damon braces, cosmetic dentistry and more at SunCare Dental San Juan del Sur and Managua. Book a free consultation.", "Dra. Cora Baltodano, DDS – especialista en ortodoncia. Implantes, brackets Damon, odontología estética y más en SunCare Dental San Juan del Sur y Managua. Agenda tu consulta gratis."),
    tr("dentist San Juan del Sur, dentist Nicaragua, orthodontist Managua, dental implants Nicaragua", "dentista San Juan del Sur, dentista Nicaragua, ortodoncista Managua, implantes dentales Nicaragua"),
    "/img/hero-cora.jpg"
  );
  return (
    <>
      <Hero />
      <section className="py-20 sm:py-28 border-b border-[#00C9B7]/10" data-testid="assist-section">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal from="up" className="space-y-6 flex flex-col items-center">
            <p className="text-xs uppercase tracking-[0.3em] text-[#00C9B7] font-semibold">{tr("Next-day dental care", "Atención dental al día siguiente")}</p>
            <Typewriter className="font-display uppercase text-3xl sm:text-5xl leading-tight">{tr("Have Questions or Need Immediate Assistance?", "¿Tienes preguntas o necesitas atención inmediata?")}</Typewriter>
            <p className="text-lg text-slate-300 max-w-xl">{tr("Need immediate assistance in San Juan del Sur or Managua? Inquire about Next Day Dental care at the office closest to you and see if there is availability!", "¿Necesitas atención inmediata en San Juan del Sur o Managua? ¡Consulta por atención dental al día siguiente en la clínica más cercana y verifica la disponibilidad!")}</p>
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <NextDayButton office="sjds" showCity testId="next-day-sjds-btn" className="bg-[#25D366] border-[#25D366] text-white" />
              <NextDayButton office="managua" showCity testId="next-day-managua-btn" className="bg-[#25D366] border-[#25D366] text-white" />
            </div>
          </Reveal>
        </div>
      </section>
      <SjdsDivider />
      <section id="services" className="py-24 sm:py-32" data-testid="home-services-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
            <SectionTitle eyebrow={tr("What I do", "Lo que hago")} title={tr(<>Services &<br />Procedures</>, <>Servicios y<br />Procedimientos</>)} />
            <Reveal from="right"><Link to="/services" className="text-xs uppercase tracking-[0.25em] text-[#00C9B7] hover:text-white" data-testid="home-all-services-link">{tr("View all services →", "Ver todos los servicios →")}</Link></Reveal>
          </div>
          <ServicesGrid />
        </div>
      </section>
      <ManaguaDivider />
      <InstagramCta />
      <InstagramFeed />
      <section className="py-16 sm:py-24" data-testid="exceptional-care-band">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Reveal from="zoom"><Link to="/contact-me" data-testid="exceptional-care-link"><img src="/img/exceptional-care.jpg" alt="Exceptional care. Beautiful smiles. SunCare Dental" className="w-full rounded-[2rem] hover:scale-[1.01] transition-transform duration-500" /></Link></Reveal>
        </div>
      </section>
      <Reviews />
      <WhyCora />
      <section className="py-16 bg-[#00C9B7] text-[#031312] overflow-hidden" data-testid="quote-band">
        <Reveal from="left" className="max-w-7xl mx-auto px-5 sm:px-8 font-display uppercase text-3xl sm:text-5xl leading-tight">{tr("\"From Managua to San Juan Del Sur, caring is in my nature!\"", "\"¡De Managua a San Juan del Sur, cuidar está en mi naturaleza!\"")}</Reveal>
      </section>
      <BlogTeaser />
      <ContactBlock />
    </>
  );
}
